
import { Dispatch } from '@reduxjs/toolkit';

class reduxManager {
  dispatch: Dispatch<any>;
  store?: { getState: () => any };
}

const ReduxManager = new reduxManager();
export default ReduxManager;
